export default "__VITE_ASSET__CTguD2ae__"